module.exports = __webpack_public_path__ + "static/img/ley.87c8311.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ley.png
// module id = Z4VU
// module chunks = 9